import { makeDataState, makePaginationState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  user: makeDataState(),
  stories: makePaginationState(),
  followers: makePaginationState(),
  followings: makePaginationState(),
  communityPosts: makePaginationState(),
  restriction: makeDataState(),
};

const _protectCachedFollowerCount = (data) => {
  if (data.isFollowing && data.followerCount === 0) {
    return {
      ...data,
      followerCount: 1,
    };
  }

  return data;
};

const _likeCommunityIterator = (item, id) => {
  if (item.id === parseInt(id, 10)) {
    return {
      ...item,
      isLiked: !item.isLiked,
      likeCount: item.isLiked ? item.likeCount - 1 : item.likeCount + 1,
    };
  }

  return item;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_USER}_PENDING`:
      return {
        ...state,
        user: {
          ...state.user,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USER}_SUCCESS`:
      return {
        ...state,
        user: {
          ...state.user,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: _protectCachedFollowerCount(action.payload.result),
        },
      };
    case `${t.FETCH_USER}_ERROR`:
      return {
        ...state,
        user: {
          ...state.user,
          status: STATUSES.ERROR,
        },
      };

    // fetch user stories
    case `${t.FETCH_USER_STORIES}_PENDING`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USER_STORIES}_SUCCESS`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.stories.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_USER_STORIES}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
        },
      };

    // fetch user communityPosts
    case `${t.FETCH_USER_COMMUNITY_POSTS}_PENDING`:
      return {
        ...state,
        communityPosts: {
          ...state.communityPosts,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USER_COMMUNITY_POSTS}_SUCCESS`:
      return {
        ...state,
        communityPosts: {
          ...state.communityPosts,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.communityPosts.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_USER_COMMUNITY_POSTS}_ERROR`:
      return {
        ...state,
        communityPosts: {
          ...state.communityPosts,
          status: STATUSES.ERROR,
        },
      };

    // follow user
    case `${t.FOLLOW_USER}_SUCCESS`:
      return {
        ...state,
        user: {
          ...state.user,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: {
            ...state.user.data,
            isFollowing: !state.user.data.isFollowing,
            followerCount: state.user.data.isFollowing
              ? state.user.data.followerCount - 1
              : state.user.data.followerCount + 1,
          },
        },
      };

    // fetch user followers
    case `${t.FETCH_USER_FOLLOWERS}_PENDING`:
      return {
        ...state,
        followers: {
          ...state.followers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USER_FOLLOWERS}_SUCCESS`:
      return {
        ...state,
        followers: {
          ...state.followers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          userId: action.meta.userId,
          pagination: {
            ...action.payload.result,
            items: state.followers.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_USER_FOLLOWERS}_ERROR`:
      return {
        ...state,
        followers: {
          ...state.followers,
          status: STATUSES.ERROR,
        },
      };

    // like community
    case `${t.LIKE_COMMUNITY_POST}_SUCCESS`: {
      const { postId } = action.meta;
      return {
        ...state,
        communityPosts: {
          ...state.communityPosts,
          pagination: {
            ...state.communityPosts.pagination,
            items: state.communityPosts.pagination.items.map((item) =>
              _likeCommunityIterator(item, postId)
            ),
          },
        },
      };
    }

    // fetch user followers
    case `${t.FETCH_USER_FOLLOWINGS}_PENDING`:
      return {
        ...state,
        followings: {
          ...state.followings,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USER_FOLLOWINGS}_SUCCESS`:
      return {
        ...state,
        followings: {
          ...state.followings,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          userId: action.meta.userId,
          pagination: {
            ...action.payload.result,
            items: state.followings.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_USER_FOLLOWINGS}_ERROR`:
      return {
        ...state,
        followings: {
          ...state.followings,
          status: STATUSES.ERROR,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        stories: makePaginationState(),
        communityPosts: makePaginationState(),
      };

    case t.RESET_COMMUNITY_POSTS:
      return {
        ...state,
        communityPosts: makePaginationState(),
      };

    case t.RESET_FOLLOW:
      return {
        ...state,
        followers: makePaginationState(),
        followings: makePaginationState(),
      };

    // block
    case `${t.TOGGLE_BLOCK_USER}_SUCCESS`:
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            isBlocked: !state.user.data.isBlocked,
          },
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_PENDING`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.PENDING,
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_SUCCESS`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          data: action.payload.result,
        },
      };

    case `${t.FETCH_USER_RESTRICTION}_ERROR`:
      return {
        ...state,
        restriction: {
          ...state.restriction,
          status: STATUSES.ERROR,
        },
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/userDetail/reducer.js